import Model from './Model';
import store from '@stores';

export default class extends Model {
  static data() {
    return {
      id: '',
      member: {
        id: '',
        first_name: '',
        last_name: '',
        email: '',
        country_code: '',
        years_of_diving: '',
        no_of_dives: '',
      },
      check_in: '',
      check_out: '',
      tourism_operator_id: '',
    };
  }

  async findById(id) {
    let url = `/groups/${id}?` + this.getParamsAsQueryParam();
    return this.getPromise(url).catch((error) =>
      $showError(
        error.response.data.message || 'something went wrong!',
        'fetch-groups'
      )
    );
  }

  async get() {
    let url = '/groups?' + this.getParamsAsQueryParam();
    return this.getPromise(url).catch((error) =>
      $showError(
        error.response.data.message || 'something went wrong!',
        'fetch-groups'
      )
    );
  }

  async addMember(groupID, member) {
    if (member.id) {
      let url = `/groups/members/${member.id}`;
      return this.patchPromise(url, member);
    }
    let url = `/groups/${groupID}/members`;
    return this.postPromise(url, member);
  }

  async removeMember(memberID) {
    let url = `/groups/members/${memberID}`;
    return this.deletePromise(url).catch((error) =>
      $showError(
        error.response.data.message || 'something went wrong!',
        'delete-group-member'
      )
    );
  }

  async fetchSightings(groupID) {
    let url = `/groups/${groupID}/sightings?` + this.getParamsAsQueryParam();
    return this.getPromise(url).catch((error) => {
      $showError(
        error.response.data.message || 'something went wrong!',
        'fetch-group-sightings'
      );
    });
  }

  async fetchCheckoutDetails(groupID) {
    let url = `/groups/${groupID}/checkout/details`;
    return this.getPromise(url).catch((error) => {
      $showError(
        error.response.data.message || 'something went wrong!',
        'fetch-group-sightings'
      );
    });
  }

  async sendAuthenticationCode(groupID) {
    let url = `/groups/${groupID}/checkout/verification-code`;
    return this.postPromise(url).catch((error) => {
      $showError(
        error.response.data.message || 'something went wrong!',
        'checkout-toast'
      );
    });
  }

  async checkout(groupID, data) {
    let url = `/groups/${groupID}/checkout/cash`;
    return this.postPromise(url, data)
      .then((response) => {
        store.dispatch('auth/changeBalance', data.amount);
        return response;
      })
      .catch((error) => {
        $showError(
          error.response.data.message || 'something went wrong!',
          'checkout-toast'
        );
      });
  }

  async save(group) {
    if (group.id) {
      let url = `/groups/${group.id}`;
      return this.patchPromise(url, group);
    }
    return this.postPromise(`/groups`, group);
  }

  async delete(id) {
    let url = `/groups/${id}`;
    return this.deletePromise(url).catch((error) =>
      $showError(
        error.response.data.message || 'something went wrong!',
        'delete-group'
      )
    );
  }
  async checkoutWithStripe(groupID, data) {
    let url = `/groups/${groupID}/checkout/stripe`;
    return this.postPromise(url, data)
      .then((response) => {
        return response;
      })
      .catch((error) => {
        $showError(
          error.response.data.message || 'something went wrong!',
          'checkout-toast'
        );
      });
  }

  async sendStripeInvoice(groupID, data) {
    data.invoice = true;
    let url = `/groups/${groupID}/checkout/stripe`;
    return this.postPromise(url, data)
      .then((response) => {
        return response;
      })
      .catch((error) => {
        $showError(
          error.response.data.message || 'something went wrong!',
          'checkout-toast'
        );

        return false;
      });
  }
}
